import Vue from "vue";
import Router from "vue-router";
import Disclaimer from "./views/disclaimerPage.vue";
import Home from "./views/Home.vue";
import Page02 from "./views/Page02.vue";
import EstimatePage from "./views/EstimatePage.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/home",
      name: "home",
      component: Home,
      props: true
    },
    {
      path: "/page02",
      name: "page02",
      component: Page02,
      props: true
    },
    {
      path: "/EstimatePage",
      name: "estimatepage",
      component: EstimatePage,
      props: true
    },
    {
      path: "/",
      name: "disclaimerPage",
      component: Disclaimer,
      props: false
    }



  ]
});
